import { zodResolver } from '@hookform/resolvers/zod';
import { isAxiosError } from 'axios';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';

import {
  ForgotPasswordFields,
  ForgotPasswordSchema,
} from '@/features/auth/types';

import { useForgotPasswordMutation } from './use-forgot-password-mutation';

export const useForgotPasswordForm = () => {
  const form = useForm<ForgotPasswordFields>({
    resolver: zodResolver(ForgotPasswordSchema),
    defaultValues: {
      email: '',
    },
    mode: 'onSubmit',
  });

  const { mutateAsync, isPending, isSuccess } = useForgotPasswordMutation();

  const onSubmit = useCallback(
    async (values: ForgotPasswordFields) => {
      await mutateAsync(values.email);
      try {
      } catch (error) {
        if (isAxiosError(error)) {
          form.setError('root', {
            message: error.response?.data.error,
          });
        } else {
          form.setError('root', {
            message: 'An error occurred while signing in',
          });
        }
      }
    },
    [form, mutateAsync],
  );

  return {
    form,
    onSubmit,
    isPending,
    isSuccess,
  };
};
